import {Tooltips} from './tooltips';
import {MatchHeight} from './match-height';
import {Tab} from './tab';

//Vue components
import { createApp } from 'vue';
import VuePocketGuidelines from './modules/VuePocketGuidelines';
import SurgeonSearch from './modules/SurgeonSearch';
import VueTinySlider from 'vue-tiny-slider';
import PageVideos from './page/PageVideos.vue';
import PageVideoCategory from './page/PageVideoCategory.vue';
import PageVideoTag from './page/PageVideoTag.vue';
import RecentVideos from './modules/RecentVideos.vue';
import OtherVideos from './modules/OtherVideos.vue';
import ShareButton from './modules/ShareButton.vue';
import VideoSearch from './modules/VideoSearch.vue';
import vClickOutside from "click-outside-vue3";
import VueSocialSharing from 'vue-social-sharing';
import ButtonBack from './modules/ButtonBack.vue';

export class App {

    constructor()
    {
        this.matchHeight = {selector: ''};
        this.tooltips = {selector: '', id: ''};
        this.tab = {selector: 'tabs'};
    }

    initVue()
    {

        createApp({
            components: {
                'pocket-guidelines' : VuePocketGuidelines,
                'surgeon-search' : SurgeonSearch,
				'tiny-slider': VueTinySlider,
                PageVideos,
                RecentVideos,
                OtherVideos,
                ShareButton,
                VideoSearch,
                PageVideoCategory,
                PageVideoTag,
                ButtonBack

            },

            data() {
                return {
                    openMenu: false,
                    overlayMenu: false,
                    openSearch: false,
                }
            },
        }).use(vClickOutside).use(VueSocialSharing).mount("#app");
    }


    // Same height initialization
    initSameHeight()
    {
        const matchHeight = new MatchHeight(this.matchHeight.selector);
        matchHeight.init();
    }

    // Tooltips initialization
    initTooltips()
    {
        const tooltips = new Tooltips(this.tooltips.selector, this.tooltips.id);
        tooltips.init();
    }

    initTab()
    {
        let tabs = document.getElementsByClassName(this.tab.selector);
        if (tabs.length) {
            for (let i = 0; i < tabs.length; i++) {
                const tab = new Tab(tabs[i]);
                tab.init();
            }
        }
    }

    init()
    {
        this.initVue();
        this.initSameHeight();
        this.initTooltips();
        this.initTab();
    }

}

